var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11.786,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.714 5.625h-13.928a.536.536 0 0 0 -.536.536v10.714a.536.536 0 0 0 .536.536h13.928a.536.536 0 0 0 .536-.536v-10.714a.536.536 0 0 0 -.536-.536zm-6.636 6.851a.536.536 0 0 1 -.658 0l-5.243-4.076.658-.846 4.915 3.821 4.916-3.823.658.846z",
    fill: "#3c2f87",
    transform: "translate(-2.25 -5.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c60f0d772cf07a4f050f9e63c5cf9f06.svg";
export { ForwardRef as ReactComponent };